import { ReactNode } from 'react';
import styled from 'styled-components';

import { ModalCloseButton as CloseButtonBase } from 'components/Button';
import { useOnWindowKeyDown } from 'hooks/useOnWindowKeyDown';
import { colors } from 'theme/theme';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 9999;
  opacity: 0.85;
  background-color: ${colors.mediumContentGrey};
`;

const Content = styled.div`
  position: fixed;
  display: flex;
  align-items: flex-start;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  overflow: auto;
  text-align: center;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
  cursor: pointer;

  &:after {
    vertical-align: middle;
    display: inline-block;
    height: 100%;
    margin-left: -0.05em;
    content: '';
  }
`;

export const Dialog = styled.div`
  position: relative;
  outline: 0;
  width: 100%;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.4);
  display: block;
  text-align: left;
  box-sizing: border-box;
  max-width: 520px;
  margin: auto;
  cursor: default;
  color: ${colors.mediumContentGrey};
  line-height: 1.5;
`;

// Prevent clicks from going through to the backdrop
Dialog.defaultProps = {
  onClick: (event) => event.stopPropagation(),
};

export const CloseButton = styled(CloseButtonBase)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
`;

type Props = {
  className?: string | undefined;
  onClose?: () => void;
  customOverlay?: ReactNode;
  children: ReactNode;
};

export function ModalBase({
  className,
  onClose,
  customOverlay,
  children,
}: Props) {
  useOnWindowKeyDown(['Escape'], onClose);

  return (
    <>
      {customOverlay || <Overlay />}

      <Content
        className={className}
        onClick={onClose}
        aria-modal="true"
        id="idealist-modal-container"
      >
        {children}
      </Content>
    </>
  );
}
